module.exports = {
    label: "brf-value list-group-item-text"
}


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/ItemToStringTemplate-style.js
 **/